import { PliValueType } from './pli-value-type';
import { PliAverageType } from './pli-average-type';

export class PliAverage {
  pliAverageId: number;
  value: number;
  pliValueType: PliValueType;
  pliAverageType: PliAverageType;
}
